const AUTH_SUCCESS = 'AUTH_SUCCESS';
const AUTH_FAIL = 'AUTH_FAIL';
const LOGOUT = 'LOGOUT';

export default {
  AUTH_SUCCESS,
  AUTH_FAIL,
  LOGOUT
};



// WEBPACK FOOTER //
// ./src/redux/auth/types.js